import * as dcbm from '@leandredev/dcbm-ng-lib';

import { IHttpOption, ApiHelper } from '@leandredev/dcbm-ng-lib';

import { Observable } from 'rxjs';
import { interfaces as I, IHttpResult } from '@leandredev/dcbm-common-lib';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiService } from '../api/api.service';

@Injectable()
export class TemplateActService implements Partial<dcbm.service.TemplateAct> {
  private service: dcbm.service.TemplateAct;

  constructor(private http: HttpClient, private apiService: ApiService) {
    this.service = new dcbm.service.TemplateAct(this.http, true);
    this.service.urlCollection = `${environment.data.api}templateAct/`;
  }

  // API methods =======================================================================================================

  create<T extends I.ITemplateAct, U extends I.ITemplateAct>(body: U, query: object, options?: IHttpOption): Observable<IHttpResult<T>> {
    return this.service.create(body, query, options);
  }

  update<T extends I.ITemplateAct, U extends I.ITemplateAct>(body: U, query: object, options?: IHttpOption): Observable<IHttpResult<T>> {
    return this.service.update(body, query, options);
  }

  delete<T extends I.ITemplateAct>(query: object, id: string, options?: IHttpOption): Observable<IHttpResult<T>> {
    return this.service.delete(query, id, options);
  }

  // ===================================================================================================================

  public getActType(): Observable<I.IActType[]> {
    return this.apiService.collections.ActType.get('readOnly/true/$bool/=/').pipe(
      ApiHelper.resultToArrWEmptyError('Aucun type pour la creation des actes')
    );
  }

  public addTemplateAct(templateAct: I.ITemplateAct): Observable<I.ITemplateAct> {
    return this.create(templateAct, {}).pipe(ApiHelper.resultToObj('Error'));
  }
}
